export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_USER = 'SET_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const SET_PDF_METADATA = 'SET_PDF_METADATA'
export const FLUSH_PDF_METADATA = 'FLUSH_PDF_METADATA'
